import FileUploader from '@/agilis/components/FileUploader/FileUploader'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  mixins: [FileUploader],
  data () {
    return {
      showDialog: false,
      fileUrl: '',
      isImage: false
    }
  },
  computed: {
    ...mapGetters({
      loaders: 'loaderStore/loading'
    }),
    loading () {
      return this.loaders['attachments-progress']
    },
    deleting () {
      return this.loaders['delete-attachment']
    },
    downloading () {
      return this.loaders['download-attachment']
    }
  },
  methods: {
    showImage (url) {
      this.fileUrl = url
      this.isImage = true
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
      this.fileUrl = ''
    },
    onFileClickMobile (attachment, download = true) {
      this.startLoader({ id: 'download-attachment', value: attachment.id })

      const url = Vue.axios.agilisUrlTrackerAttachmentsEdit(
        this.applicationId,
        this.trackerTypeId,
        this.trackerId,
        attachment.id
      )

      const requestConfig = Vue.axios.agilisRequestConfig(url)
      requestConfig.responseType = 'blob'

      Vue.axios.get(url, requestConfig)
        .then(response => {
          const blob = new Blob([response.data], { type: attachment.mimeType })
          const blobUrl = URL.createObjectURL(blob)

          if (attachment.mimeType.startsWith('image/')) {
            this.showImage(blobUrl)
          } else {
            const reader = new FileReader()
            reader.onload = (event) => {
              const arrayBuffer = event.target.result
              const blobUrl = URL.createObjectURL(new Blob([arrayBuffer], { type: attachment.mimeType }))
              const link = document.createElement('a')
              link.href = blobUrl
              link.download = attachment.filename
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

              // Cleanup
              setTimeout(() => {
                URL.revokeObjectURL(blobUrl)
              }, 0)
            }

            reader.onerror = (error) => {
              console.error('FileReader error', error)
              this.notifyError(error)
            }

            reader.readAsArrayBuffer(blob)
          }
        })
        .catch(error => {
          this.notifyError(error)
        })
        .finally(() => {
          this.stopLoader({ id: 'download-attachment' })
        })
    },

    formatBytes (bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  }
}
